<confirm-dialog #passwordExpiringDialog [showRejectButton]="false" [showCloseButton]="true" [showConfirmButton]="false" [showCloseIcon]="true"></confirm-dialog>